import { get } from '../lib/tycho';
import * as types from './ActionTypes';

export const fetchPalette = () => {
  return (dispatch, getState) => {
    if (getState().colors.isPaletteLoading) {
      return;
    }
    dispatch({
      type: types.COLOR_PALETTE_REQUEST
    });

    return get('v1/colors/palette')
      .then(res => res.json())
      .then(palette => dispatch({type: types.COLOR_PALETTE_RECEIVE, payload: palette}));
  };
};

let fetchColorsPromise;

export const fetchColors = () => {
  return dispatch => {
    if (fetchColorsPromise || location.pathname.startsWith('/p/')) {
      return fetchColorsPromise;
    }

    dispatch({type: types.COLORS_REQUEST});

    fetchColorsPromise = get('v1/colors/objects')
      .then(res => {
        fetchColorsPromise = null;
        return res.json();
      })
      .then(colors => dispatch({
        type: types.COLORS_RECEIVE,
        payload: colors
      }));

    return fetchColorsPromise;
  };
};
